import axios from 'axios';

export const isAbortError = (error: unknown) =>
    axios.isCancel(error) ||
    (error instanceof DOMException && error.name === 'AbortError') ||
    (typeof error === 'object' &&
        error !== null &&
        'code' in error &&
        (error as { code?: string }).code === 'ERR_CANCELED');

type ActiveRequest = {
    id: number;
    controller: AbortController;
};

/** 取消上一次未完成的请求，避免筛选/排序切换时的竞态覆盖 */
export class RequestGuard {
    private active: ActiveRequest | null = null;

    begin() {
        this.active?.controller.abort();
        const controller = new AbortController();
        const id = (this.active?.id ?? 0) + 1;
        this.active = { id, controller };
        return { id, signal: controller.signal };
    }

    isCurrent(id: number) {
        return this.active?.id === id;
    }

    abort() {
        this.active?.controller.abort();
        this.active = null;
    }
}
